import React, { Fragment, useReducer, useEffect } from "react";
import ReactDOM from "react-dom";
import SearchList from "../shared/search_list";
import Squares from "react-activity/lib/Squares";
import "react-activity/lib/Squares/Squares.css";

const reducer = (state, { type, payload }) => {
  switch (type) {
    case "setIsLoading":
      return { ...state, isLoading: true };
    case "setQuery":
      return { ...state, query: payload };
    case "setSort":
      return { ...state, sort: payload };
    case "toggleSection":
      const sections = new Set(state.sections);
      sections.has(payload) ? sections.delete(payload) : sections.add(payload);
      return { ...state, sections };
    case "setGroups":
      return {
        ...state,
        result: payload.result,
        groups: payload.groups,
        isLoading: false
      };
    default:
      return state;
  }
};

const Search = ({
  iconPath,
  filterQuery,
  filterSorts,
  filterSections,
  translation
}) => {
  const [state, dispatch] = useReducer(reducer, {
    isLoading: false,
    result: "",
    groups: {},
    query: filterQuery || "",
    sort: "importance",
    sections: new Set(filterSections.map(sect => +sect.id))
  });

  function performSearch() {
    const sects = [...state.sections].map(id => `sections[]=${id}`).join("&");
    dispatch({ type: "setIsLoading", payload: true });
    const query = encodeURIComponent(state.query);
    fetch(`/amusements/search.json?query=${query}&sort=${state.sort}&${sects}`)
      .then(resp => resp.json())
      .then(payload => dispatch({ type: "setGroups", payload }));
  }

  useEffect(() => {
    performSearch();
  }, []);

  function handleKeyDown(e) {
    if (e.keyCode !== 13) return;
    performSearch();
  }

  return (
    <Fragment>
      <h1 className="search-page__title">{state.result}</h1>
      <div className="search-page__content">
        <div className="search-page__content">
          <ul className="grid search-page__grid">
            <li className="grid__col grid__col_xl_3 grid__col_lg_12 search-page__grid-item">
              <div className="search-page__filter">
                {/* <button className="search-page__filter-button">Фильтр</button> */}
                <div
                  className="search-page__field"
                  style={{ display: "block", position: "static" }}
                >
                  <div className="search-page__field-content">
                    <div className="search-page__field-block">
                      <div className="search">
                        <div className="search__block">
                          <button
                            className="button--icon"
                            onClick={performSearch}
                            type="button"
                          >
                            <svg className="search__icon search__icon_s_x">
                              <use xlinkHref={`${iconPath}#icon_search`} />
                            </svg>
                          </button>
                          <label className="visually-hidden">
                            {translation.button}
                          </label>
                          <input
                            autoFocus
                            className="search__input"
                            placeholder={translation.input_placeholder}
                            value={state.query}
                            onKeyDown={handleKeyDown}
                            onChange={e =>
                              dispatch({
                                type: "setQuery",
                                payload: e.target.value
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="search-page__field-block">
                      <p className="search-page__filter-title">
                        {translation.sort}
                      </p>
                      {Object.keys(filterSorts).map(key => (
                        <label
                          key={key}
                          className="form-button radio search-page__filter-item"
                        >
                          <input
                            type="radio"
                            className="form-button__input"
                            checked={state.sort === key}
                            onChange={() =>
                              dispatch({ type: "setSort", payload: key })
                            }
                          />
                          <span className="form-button__icon radio__icon" />
                          <span className="form-button__text">
                            {filterSorts[key]}
                          </span>
                        </label>
                      ))}
                    </div>
                    <div className="search-page__field-block">
                      <p className="search-page__filter-title">
                        {translation.sections}
                      </p>
                      {filterSections.map(({ id, name }) => (
                        <label
                          key={id}
                          className="form-button checkbox search-page__filter-item"
                        >
                          <input
                            type="checkbox"
                            className="form-button__input"
                            checked={state.sections.has(id)}
                            onChange={() =>
                              dispatch({
                                type: "toggleSection",
                                payload: id
                              })
                            }
                          />
                          <svg
                            className="form-button__icon checkbox__icon"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              className="checkbox__icon-box"
                              height="18"
                              rx="5"
                              width="18"
                              x="1"
                              y="1"
                            />
                            <path
                              className="checkbox__icon-check"
                              d="M4,10L8,14L16.5,5.5"
                            />
                          </svg>
                          <span className="form-button__text">{name}</span>
                        </label>
                      ))}
                    </div>
                    <div className="search-page__field-block search-page__field-block_button">
                      <button
                        className="button button--m button--default"
                        onClick={performSearch}
                        type="button"
                      >
                        <div className="button__block">
                          <span className="button__text">
                            {translation.button}
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="grid__col grid__col_xl_9 grid__col_lg_12 search-page__grid-item">
              {state.isLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Squares size={32} color="#FB6400" />
                </div>
              ) : (
                <SearchList groups={state.groups} iconPath={iconPath} />
              )}
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

const searchElement = document.getElementById("search");
const query = searchElement.dataset.query;
const sorts = JSON.parse(searchElement.dataset.sorts);
const sections = JSON.parse(searchElement.dataset.sections);
const iconPath = searchElement.dataset.icon;
const translation = JSON.parse(searchElement.dataset.translation);
ReactDOM.render(
  <Search
    iconPath={iconPath}
    filterQuery={query}
    filterSorts={sorts}
    filterSections={sections}
    translation={translation}
  />,
  searchElement
);
